import logo from "../assets/img/creative_flare_logo.jpeg";
import { cn } from "../lib/utils";

export function Logo({ className = "h-10 w-10", alt = "Creative Flare Yorkshire C.I.C." }) {
  return (
    <img
      src={logo}
      alt={alt}
      className={cn("rounded-full object-cover bg-white shrink-0", className)}
    />
  );
}
